module.exports = __webpack_public_path__ + "static/media/columnIcon.e82aea2d.svg";